module.exports = {
    RBTree: require('./lib/rbtree'),
    BinTree: require('./lib/bintree')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/bintrees/index.js
// module id = JMHU
// module chunks = 3 4 5 6 7 8 9